import HTTP from '@/utils/http';
import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';

const defaultState = () => ({
  current: null,
  plans: [],
});

const plansModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET(state, { plans }) {
      state.plans = plans;
    },
    SET_CURRENT(state, { plan }) {
      state.current = plan;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET({ commit }) {
      return HTTP({
        url: 'plans',
      }).then((response) => {
        commit('SET', { plans: response.data.data });
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.fetch', { name: 'plans' }), icon: 'times', type: 'error' }));
      });
    },
    GET_CURRENT_PLAN({ commit }) {
      return HTTP({
        url: 'plans/current',
      }).then((response) => {
        commit('SET_CURRENT', { plan: response.data.data });
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.fetch', { name: 'current plan' }), icon: 'times', type: 'error' }));
      });
    },
    SET_CURRENT_PLAN({ commit, dispatch }, {
      id, voucherCode, cancelReason = null, cancelReasonComments = null,
    }) {
      const data = {
        plan_id: id,
        voucher_secret: voucherCode,
      };
      if (cancelReason) {
        data.cancel_reason = cancelReason;
      }
      if (cancelReasonComments !== null) {
        data.cancel_reason_comments = cancelReasonComments;
      }
      return HTTP({
        method: 'put',
        url: 'plans/current',
        data,
        suppressServerErrors: true,
      }).then((response) => {
        commit('SET_CURRENT', { plan: response.data.data });
        dispatch('plan/GET', {}, { root: true });
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.success.switch', { name: 'plan' }), icon: 'check', type: 'success' }));
        return { switchResult: response.data.data };
      }).catch((error) => { // eslint-disable-line arrow-body-style
        return { switchError: error };
      });
    },
  },
  getters: {
    results: state => state.plans,
    current: state => state.current,
  },
};

export default plansModule;
